import * as Sentry from '@sentry/react';

export function initSentry() {
  if (import.meta.env.VITE_SENTRY_DSN) {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.VITE_APP_ENV || 'development',
      release: import.meta.env.VITE_SENTRY_RELEASE || '1.0.0',
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
      ],
      tracesSampleRate: 0.2,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      beforeSend(event) {
        // Don't send events in development
        if (import.meta.env.DEV) return null;
        return event;
      },
    });
  }
}

export function setUser(user) {
  if (user) {
    Sentry.setUser({ id: user.id, email: user.email, role: user.role });
    Sentry.setTag('tenant_id', user.tenant_id);
  } else {
    Sentry.setUser(null);
  }
}

export function captureError(error, context) {
  Sentry.captureException(error, { extra: context });
}
